<template>
  <div class="key-table">
    <key-form-modal
      :active.sync="modalForm.active"
      @generate="() => fetchKeys()"
    />
    <div class="buttons">
      <b-button @click="() => (modalForm.active = true)" v-if="canManageApiKeys">Create</b-button>
      <b-button
          tag="a"
          href="https://v0623.stormport.nz/docs"
          target="_blank"
      >
        Documentation
      </b-button>
    </div>
    <base-table
      :service="$options.keyService"
      fetch-func="all"
      :fetch-params="{
        user_id: $store.state.Auth.user.id,
      }"
      :columns="columns"
      ui-pagination
      ref="baseTable"
    >
      <template #rowActions="{ row }">
        <b-button
          type="is-danger"
          size="is-small"
          @click="() => onKeyDelete(row)"
          v-if="canManageApiKeys"
        >
          DELETE
        </b-button>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import KeyFormModal from "@/components/Key/KeyFormModal";
import { KeyService } from "@/services/key.service";

export default {
  keyService: KeyService,
  components: {
    BaseTable,
    KeyFormModal,
  },
  data() {
    return {
      columns: [
        { label: "Name", field: "name" },
        { label: "Key", field: "value" },
        { label: "Expiry", field: "expiry" },
        { label: "", field: "actions" },
        {
          label: "",
          field: "actions",
          meta: {
            rowSlot: "rowActions",
          },
        },
      ],
      modalForm: {
        active: false,
      },
    };
  },
  computed: {
    canManageApiKeys() {
      return this.$store.getters["Auth/hasPermission"](
        "can manage api keys"
      );
    },
  },
  mounted() {
    this.fetchKeys();
  },
  methods: {
    async fetchKeys() {
      await this.$refs.baseTable.fetchData();
    },
    async revokeKey(key) {
      try {
        this.$refs.baseTable.loading = true;
        await KeyService.delete(key.id);
        await this.fetchKeys();
        this.$buefy.toast.open({
          message: "Access key has been revoked.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        this.$buefy.toast.open({
          message: "Failed to revoke access key.",
          type: "is-danger",
          position: "is-top-right",
        });
      } finally {
        this.$refs.baseTable.loading = false;
      }
    },
    onKeyDelete(key) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message:
          "Any applications or scripts using this key will no longer be able to access the API. You cannot undo this action.",
        confirmText: "Revoke Key",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.revokeKey(key),
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Key/KeyTable.vue